import { HallActionList, HallType } from "../actions/hallAction";
import { Action } from "../actions/types";

const initialValue: Array<HallType> = [];

const hallReducer = (state: Array<HallType> = initialValue, action: Action) => {
    switch (action.type) {
        case HallActionList.ADD_HALL:
            return [
                ...state,
                action.data,
            ];

        case HallActionList.UPDATE_HALL:
            const updated = [...state].slice();
            const index = updated.findIndex(u => u.id === action.data.id);

            if (index > -1) {
                updated[index] = {
                    ...action.data,
                };
            }

            return updated;

        case HallActionList.FETCH_HALL:
            return action.data;

        case HallActionList.DELETE_HALL:
            return state.filter(s => s.id !== action.data);

        default:
            return state;
    }
}

export default hallReducer;



